import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-component',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.loadScriptWithCacheBusting();
  }

  loadScriptWithCacheBusting(): void {
    const cacheBust = new Date().getTime();
    const scriptUrl = `../assets/scripts/acessibilidade.js?v=${cacheBust}`; // Altere para o caminho do seu arquivo
    const script = this.renderer.createElement('script');
    script.src = scriptUrl;
    script.type = 'text/javascript';
    this.renderer.appendChild(document.body, script);
  }
}
